import { useEffect } from "react";
import { toast } from "sonner";

export function useContentProtection() {
  useEffect(() => {
    const handleContextMenu = (e) => { e.preventDefault(); };
    const handleKeyDown = (e) => {
      if (
        (e.ctrlKey && ["c","C","p","P","s","S","u","U"].includes(e.key)) ||
        e.key === "PrintScreen" ||
        (e.metaKey && ["c","C","p","P","s","S"].includes(e.key))
      ) {
        e.preventDefault();
        toast.info("Content is protected", { duration: 2000 });
      }
    };
    const handleDragStart = (e) => { e.preventDefault(); };
    document.addEventListener("contextmenu", handleContextMenu);
    document.addEventListener("keydown", handleKeyDown);
    document.addEventListener("dragstart", handleDragStart);
    return () => {
      document.removeEventListener("contextmenu", handleContextMenu);
      document.removeEventListener("keydown", handleKeyDown);
      document.removeEventListener("dragstart", handleDragStart);
    };
  }, []);
}
